<template>
    <div>
        <userCard></userCard>
        <div class="list-container">
            <a class="item" href="javascript:;" @click="goGift">
                <img src="https://oss.cloud.custouch.com/res/44636/积分商城.png" />
                <span>积分商城</span>
            </a>
            <router-link class="item" :to="{ name: 'record' }">
                <img src="https://oss.cloud.custouch.com/res/44635/积分兑换.png" />
                <span>积分记录</span>
            </router-link>
        </div>
    </div>
</template>

<script >
import userCard from './components/userCard'
import { getEgRedirect, syncAddress } from '@/service/member'
export default {
    components: {
        userCard
    },
    methods: {
        async goGift() {
            try {
                // syncAddress()
                const { url } = await getEgRedirect()
                if (url) {
                    window.location.href = url
                } else {
                    throw Error('跳转异常')
                }
            } catch (error) {
                this.$message.fail(error.message)
            }
        }
    }
}
</script>
<style scoped lang="less">
.list-container {
    padding: 1.4rem 1rem 0rem 1rem;
    display: flex;
    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 4.2rem;
        height: 4.2rem;
        background-color: #f1f1f1;
        margin-right: 1.9rem;
        border-radius: 5px;
        font-weight: 500;
        img {
            width: 30%;
            object-fit: contain;
            margin-bottom: 0.5rem;
        }
    }
}
</style>
